import { render, staticRenderFns } from "./jsonViewer.vue?vue&type=template&id=66d73d4c&scoped=true&"
import script from "./jsonViewer.vue?vue&type=script&lang=js&"
export * from "./jsonViewer.vue?vue&type=script&lang=js&"
import style0 from "./jsonViewer.vue?vue&type=style&index=0&id=66d73d4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d73d4c",
  null
  
)

export default component.exports